// src/components/LatestProduct/LatesProduct.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useCurrency } from "../../components/PriceFormat/PriceFormat";
import { pickDisplayPrice, formatMoney } from "../../utils/pricePicker";

const normalizeCurr = (c) => {
  const up = String(c || "TRY").toUpperCase();
  return up === "TL" ? "TRY" : up;
};

const isPerfume = (p) => {
  const c = p?.category;
  const has = (s) =>
    String(s || "")
      .toLowerCase()
      .includes("perfume") ||
    String(s || "")
      .toLowerCase()
      .includes("parfum") ||
    String(s || "")
      .toLowerCase()
      .includes("parfüm");
  if (Array.isArray(c)) return c.some(has);
  if (typeof c === "string") return has(c);
  return false;
};

// Parfüm için manual_prices öncelikli; değilse pickDisplayPrice
const pickPerfAwarePrice = (product, currency) => {
  const curr = normalizeCurr(currency);
  if (isPerfume(product)) {
    const mp = product?.manual_prices || product?.manualPrices;
    const v = mp?.[curr];
    if (v != null && !Number.isNaN(Number(v))) {
      return { amount: Number(v), curr };
    }
  }
  return pickDisplayPrice(product, curr); // mevcut akış
};

const LatesProduct = () => {
  const [products, setProducts] = useState([]);
  const { currency } = useCurrency();

  useEffect(() => {
    let mounted = true;

    axios
      .get(`${process.env.REACT_APP_API_URL}/products`)
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];

        // Fisher–Yates karıştır, ilk 4
        const arr = [...list];
        for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        if (mounted) setProducts(arr.slice(0, 4));
      })
      .catch((err) => {
        console.error("Ürünleri alırken hata oluştu:", err);
        if (mounted) setProducts([]);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const getProductImage = (product) => {
    if (product?.color_images?.[0]?.images?.length > 0) {
      return product.color_images[0].images[0];
    }
    return (
      product?.default_images?.[0] ||
      "https://apimukemel.com/api/assets/BTC0001-1.webp"
    );
  };

  const renderPrice = (product) => {
    const picked = pickPerfAwarePrice(product, currency);
    if (!picked) return null;

    const { amount, curr } = picked;
    const isTRY = curr === "TRY" || curr === "TL";
    const opts = isTRY
      ? amount < 1000
        ? { min: 1, max: 1 }
        : { min: 0, max: 0 }
      : { min: 0, max: 0 };

    return formatMoney(amount, curr, opts);
  };

  return (
    <>
      {products.map((product) => {
        const inStock = String(product?.availability || "")
          .toLowerCase()
          .includes("in stock");
        return (
          <div
            key={product.id}
            className="col-lg-3 col-md-6 col-sm-6 col-12 pe-0 px-0 mb-0 mt-0"
          >
            <a href={`/product/${product.id}`} className="text-decoration-none">
              <div className="cardbg">
                <img
                  src={getProductImage(product)}
                  className="d-block w-100"
                  alt={product.name}
                />
              </div>
              <div className="px-4 bg-light pt-2 pb-2">
                <h5 className="mb-0 text-dark">{product.name}</h5>
                {inStock ? (
                  <h6 className="text-muted mt-1">{renderPrice(product)}</h6>
                ) : (
                  <h6 className="fw-bold mt-1 text-danger">Out of Stock!</h6>
                )}
              </div>
            </a>
          </div>
        );
      })}
    </>
  );
};

export default LatesProduct;
